import {BaseStore, globalStore, StoreObject} from "../../../stem-core/state/Store.js";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {BaseEnum, makeEnum} from "../../../stem-core/state/BaseEnum.js";
import {formatPercentFromRatio} from "../../../stem-core/base/Formatting.js";
import {Merchant} from "../MerchantStore";
import {MerchantAudience} from "./MerchantAudienceStore";
import {StemDate} from "../../../stem-core/time/Date";

@makeEnum
export class MerchantEmailCampaignStatus extends BaseEnum {
    static UNSCHEDULED;
    static VALIDATION_FAILED;
    static SCHEDULED;
    static STARTED;
    static STOPPED;
    static FINISHED;
}

export class EmailSendingStoreObject extends StoreObject {
    @field(Number) numSentEmails: number;
    @field(Number) numReadEmails: number;
    @field(Number) numBouncedEmails: number;
    @field(Number) numFailedEmails: number;
    @field(Number) totalNumReads: number;

    getAllFailed() {
        return this.numBouncedEmails + this.numFailedEmails;
    }

    formatOpenPercent() {
        return formatPercentFromRatio(this.numReadEmails, this.numSentEmails);
    }
}

@globalStore
export class MerchantEmailCampaign extends BaseStore("MerchantEmailCampaign", {}, EmailSendingStoreObject) {
    @field("Merchant") merchant: Merchant;
    @field("MerchantAudience") audience: MerchantAudience;
    @field(String) name: string;
    @field(Date) createdAt: StemDate;
    @field(Date) scheduledSendDate: StemDate;

    getAllEmailTemplates() {
        return this.getStore("EmailTemplate").filterBy({campaignId: this.id});
    }
}

export async function apiMerchantCreateEmailCampaign(request) {
    const response = await apiClient.post("/merchant/create_email_campaign/", request);
    return MerchantEmailCampaign.loadObject(response);
}

export async function apiMerchantEditEmailCampaign(request) {
    return apiClient.post("/merchant/edit_email_campaign", request);
}

export async function apiMerchantDeleteEmailCampaign(request) {
    return apiClient.post("/merchant/delete_email_campaign", request);
}
